import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreService } from '../services/core.service';
import { UploadMediaModel, ConfigKey, ParamsMediaModel, Alert, AlertCode, ParamsMedia, MediaQueovalModel, FilterMedia, FileModel } from '../models';
import { Observable } from 'rxjs';
import { HttpService } from './dataAccess.service';
import { ToastService } from '../toast';
import { Router } from '@angular/router';
import * as fileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})

export class MediaServiceV2 {

  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private httpclient: HttpClient,
    private toast: ToastService,
    private router: Router
  ) { }

  public async deleteMedia(ident: string): Promise<boolean> {

    return this.http.getHttp<UploadMediaModel>(`${this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}api/MediaManager/DELETE_MEDIA/${ident}`).toPromise().then(
      (res: UploadMediaModel) => {
        return !res.HasError && res.CodedAlerts.filter((alert: Alert) => alert.Code === AlertCode.ERROR || alert.Code === AlertCode.BLOCKING_ERROR).length === 0
      });
  }

  /**
 * @description upload un média
 * @param file fichier à uploader
 * @param previews fichiers qui serviront de miniature
 */
  public async uploadMedia(file: File, ident: string = '', previews: File[] | File = []): Promise<ParamsMediaModel> {
    let result: ParamsMediaModel = new ParamsMediaModel();
    if (!file) {
      result.CodedAlerts = [];
      const message = "Aucun fichier n'est sélectionné";
      this.toast.showAlertToast(message, 10000);
      return result;
    }

    const config: any = {
      responseType: 'json' as 'json',
      observe: 'response'
    };
    const formData: FormData = new FormData();
    formData.append('', file, file.name);
    if (previews) {
      if ((previews as File).name) {
        previews = [(previews as File)];
      }
      (previews as File[]).forEach(f => formData.append('', f, f.name));
    }
    formData.append('token', this.indParam.AppParams.token);
    if (ident) {
      formData.append('ident', ident);
    }
   
    result = await this.httpclient.post<UploadMediaModel>(`${this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}api/UploadMedia/`, formData, config).toPromise().then(
      (res: any) => {
        let result: ParamsMediaModel = res.body;
        result = !result ? new ParamsMediaModel : result;
        return result;
    })
    return result;
  }

  /**
 * @param filter string: ident du media ou FilterMedia pour une liste filtée
 */
  public async GetMediasFromBo(filter: FilterMedia | string = new FilterMedia): Promise<ParamsMedia[]> {
    const model: MediaQueovalModel = new MediaQueovalModel;
    if (typeof filter === 'string') {
      model.MediaModel.Filter = new FilterMedia;
      model.MediaModel.Filter.byName = filter;
    } else {
      model.MediaModel.Filter = filter;
    }
    model.Mode = 'GET_MEDIAS';
    return this.http.postHttp<MediaQueovalModel>(`${this.indParam.AppParams.apiUrl}api/media/`, model).toPromise().then(
      (result: MediaQueovalModel) => {
        if (!result.HasError && !result.CodedAlerts.find((alert: Alert) => { alert.Code == AlertCode.BLOCKING_ERROR || alert.Code == AlertCode.ERROR }) && result.MediaModel && result.MediaModel.ListMedia) {
          return result.MediaModel.ListMedia;
        } else {
          return [];
        }
      });
  }

  /**
 * @description Récupération du média (retourne la destination)
 * @param MediaName nom du média avec son extension
 */
  public async getMedia(MediaName: string): Promise<ParamsMedia> {
    return this.http.getHttp<UploadMediaModel>(`${this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}api/MediaManager/GET_MEDIA/${MediaName}/`).toPromise().then(
      (result: UploadMediaModel) => {
        if (!result.HasError && !result.CodedAlerts.find((alert: Alert) => { alert.Code == AlertCode.BLOCKING_ERROR || alert.Code == AlertCode.ERROR }) && result.Media && result.Media.Media) {
          return result.Media.Media;
        } else {
          return new ParamsMedia();
        }
      });
  }

  /**
 * @description Récupération de tout les médias du client par type (stream api)
 * @param typeMedias liste des types désirés séparés par un |
 *  VIDEO|IMG|AUDIO|DOC ou ALL
 *  @example 'VIDEO', 'IMG|VIDEO', 'DOC|VIDEO|AUDIO', 'ALL'
 */
  public getAllMediasClient(typeMedias: string = 'ALL'): Promise<ParamsMedia[]> {
    return this.http.getHttp<UploadMediaModel>(`${this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}api/MediaManager/GET_ALL_MEDIAS_CLIENT/${typeMedias}/`).toPromise().then(
      (result: UploadMediaModel) => {
        if (!result.HasError && !result.CodedAlerts.find((alert: Alert) => { alert.Code == AlertCode.BLOCKING_ERROR || alert.Code == AlertCode.ERROR }) && result.Media && result.Media.ListMedia) {
          return result.Media.ListMedia;
        } else {
          return [];
        }
        
      });
  }


  // ----------------- DOWNLOAD FILE -----------------
  /**
   * Téléchargement d'un fichier
   * @param idDoc Ident du document (ou nom du fichier)
   */
  downloadFile(fileModel: FileModel): void {
    this.indParam.showSplash(true);
    // tslint:disable-next-line:radix
    fileModel.Name = (fileModel.Name.indexOf('.') === -1 && !isNaN(parseInt(fileModel.Name))) ? `${fileModel.Name}.pdf` : fileModel.Name;


    this.download(fileModel).subscribe((response: any) => {

      // code modifié (avec response -> arraybuffer) ---------------------------------------------------------
      let fileType: string = '';
      switch (fileModel.Name.split('.').pop()) {
        case 'pdf': fileType = 'application/pdf'; break;
        case 'jpg': fileType = 'image/jpg'; break;
        case 'jpeg': fileType = 'image/jpeg'; break;
        case 'png': fileType = 'image/png'; break;
        case 'gif': fileType = 'image/gif'; break;
        case 'xml': fileType = 'application/xml'; break;
        case 'txt': fileType = 'text/plain'; break;
        case 'doc': fileType = 'application/vnd.ms-word'; break;
        case 'docx': fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
        case 'xls': fileType = 'application/vnd.ms-excel'; break;
        case 'xlsx': fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
        case 'bmp': fileType = 'image/bmp'; break;
        case 'wav': fileType = 'audio/wav'; break;
        case 'ppt': fileType = 'application/vnd.ms-powerpoint'; break;
        case 'pptx': fileType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation'; break;
        case 'dwg': fileType = 'image/vnd.dwg'; break;
        case 'zip': fileType = 'octet/stream'; break;
      }
      const blob: Blob = new Blob([(response)], {
        type: fileType,
      });

      if (blob.size > 0) {
        if (window.navigator && (window.navigator.msSaveOrOpenBlob !== undefined || window.navigator.msSaveOrOpenBlob !== null) && fileType !== 'application/pdf') {
          fileSaver.saveAs(blob, fileModel.Name);
        } else {
          // Pour le PDF on l'ouvre dans une nouvelle fenêtre
          const objectUrl: string = URL.createObjectURL(blob);
          window.open(objectUrl);
        }

      }
      this.indParam.showSplash(false);

      // --------------------------------------------------------------------------------
    }, (error: any) => {
      console.error((error) ? this.indParam.getTrad('Error_EL') : `${this.indParam.getTrad('undeferron_EL')} core.service.ts`);
      this.indParam.showSplash(false);
    });
  }

  /**
   * Appel serveur pour le téléchargement
   * @param fileName Nom du fichier à télécharger
   */
  private download(fileModel: FileModel): Observable<any> {
    const data: any = { QueovalOriginalName: fileModel.Name, FilePath: fileModel.FullPath };
    const config: any = { responseType: 'arraybuffer' as 'arraybuffer' };
    // Download from streamService
    return this.httpclient.post(`${this.indParam.getConfigKey(ConfigKey.STREAM_HTTP)}api/StreamDownload`, data, config);
  }


  //private setAlertMNG(model: QueovalBase): void {
  //  if (model != null && model.CodedAlerts != null && model.CodedAlerts.length > 0) {

  //    for (let i: number = 0; i < model.CodedAlerts.length; i++) {
  //      const alert: Alert = model.CodedAlerts[i];
  //      if (alert.Message.length > 0) {
  //        switch (alert.Code) {
  //          case AlertCode.ALERT:
  //            this.toast.showWarningToast(alert.Message, alert.Message.length < 100 ? 10000 : alert.Message.length * 100);
  //            break;
  //          case AlertCode.BLOCKING_ERROR:
  //            this.toast.showAlertToast(alert.Message, alert.Message.length < 100 ? 10000 : alert.Message.length * 100);
  //            break;
  //          case AlertCode.ERROR:
  //            this.toast.showAlertToast(alert.Message, alert.Message.length < 100 ? 10000 : alert.Message.length * 100);
  //            break;
  //          case AlertCode.INFO:
  //            this.toast.showInfoToast(alert.Message, alert.Message.length < 30 ? 3000 : alert.Message.length * 100);
  //            break;
  //          case AlertCode.SUCCESS:
  //            this.toast.showSuccessToast(alert.Message, alert.Message.length < 30 ? 3000 : alert.Message.length * 100);
  //            break;
  //        }
  //      }
  //    }
  //  }
  //}
}
